export default {
  screens: [
    {
      type: 'intro',
      title: '形を変えるジュエリーの芸術',
      content:
        '「プロムナード アンペリアル」は、ロシアとシベリアの冬の美しさへのオマージュ。ここには、形を変えるジュエリーというショーメの卓越した技術が用いられています。パパラチアサファイアのきらめきに彩られたピュアなラインのネックレスはブローチにもなり、様々な身に着け方が可能です。',
      idYt: 'FAAhbyqO57o',
      videoCover: 'world/transformer/video.jpg',
      desktop: {
        cover: 'world/transformer/cover-1.jpg',
        introRight: 'world/transformer/introRight.jpg'
      },
      mobile: {
        cover: 'world/transformer/mobile-cover-1.jpg',
        contentStyle: { width: '92%' },
        coverStyle: {
          width: '34%',
          height: 'auto',
          top: '31.5vh',
          bottom: 'inherit',
          right: '-10px',
          left: 'inherit',
          position: 'absolute'
        },
        introRight: 'world/transformer/introRight.jpg'
      },
      isCover: true
    },
    {
      type: 'memento',
      img: 'world/transformer/memento.jpg',
      imgRight: 'world/transformer/mementoRight.jpg',
      mobile: {
        contentStyle: {
          width: '77.5%',
          left: '22.5%'
        }
      },
      content:
        'この卓越した技術は「トレゾール ダフリック」ハイジュエリーコレクションでも使われており、「蟻」のブローチは形を変えてイヤリングの一部となります。'
    },
    {
      type: 'column',
      middleImg: 'world/transformer/columnMiddle.jpg',
      content:
        '傑出したエメラルドを備えるこのティアラは、皇后ジョゼフィーヌの後裔であるロイヒテンベルク家に由来するものです。ショーメが好んで用いる庭園のテーマが躍動感をもって表現されており、花のモチーフは着用者の動きに応じて揺れ動きます。花はそれぞれ取り外しが可能で、ブローチとして着用することができます。'
    }
  ],
  mobile: {
    mainContentStyle: { paddingBottom: '20px' }
  }
}



// WEBPACK FOOTER //
// ./src/locales/jp/worlds/transformer.js